/* ERP: dropship payments partners entered in the Hub that the office hasn't acknowledged yet. */
import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, BellRing } from "lucide-react";
import { toast } from "sonner";
import { API, getAuthHeader } from "@/App";

const h = () => ({ headers: getAuthHeader() });
const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const DropshipPendingCredits = ({ reloadKey, onOpen, onAcked }) => {
  const [d, setD] = useState(null);
  const load = () => axios.get(`${API}/portal-admin/ds-credits/pending`, h()).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [reloadKey]);
  if (!d?.count) return null;
  const ack = async (x) => {
    try { await axios.post(`${API}/portal-admin/ds-credits/${x.id}/ack`, {}, h()); toast.success("Payment acknowledged"); load(); onAcked?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Something went wrong"); }
  };
  return (
    <div className="mb-3 rounded-xl border border-indigo-200 bg-indigo-50 p-3" data-testid="ds-pending-credits">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-semibold text-indigo-900"><BellRing className="h-4 w-4" />{d.count} dropship payment(s) to acknowledge</p>
      <div className="max-h-48 space-y-1 overflow-y-auto">{d.credits.map((x) => (
        <div key={x.id} className="flex flex-wrap items-center gap-2 rounded-lg bg-white px-2.5 py-1.5 text-xs" data-testid={`ds-pending-${x.id}`}>
          <button onClick={() => onOpen(x.partner_id, x.client_id)} className="font-semibold text-indigo-700 hover:underline">{x.partner_name} → {x.client_name}</button>
          <span className="font-bold text-emerald-700">{inr(x.amount)}</span>
          <span className="text-slate-500">{x.date.split("-").reverse().join("/")}{x.note ? ` · ${x.note}` : ""}{x.edits ? ` · edited ${x.edits}×` : ""}</span>
          <button onClick={() => ack(x)} className="ml-auto rounded-md bg-indigo-600 px-2 py-0.5 font-semibold text-white" data-testid={`ds-pending-ack-${x.id}`}>Acknowledge</button>
        </div>))}</div>
    </div>
  );
};


/* Office summary: partners whose dropship clients owe money with no payment in 15+ days. */
export const DropshipOverdueSummary = ({ reloadKey, onOpen }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => { axios.get(`${API}/portal-admin/ds-overdue`, h()).then((r) => setD(r.data)).catch(() => setD(null)); }, [reloadKey]);
  if (!d?.partners?.length) return null;
  return (
    <div className="mb-3 rounded-xl border border-rose-200 bg-rose-50 p-3" data-testid="ds-overdue-summary">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center gap-1.5 text-left text-sm font-semibold text-rose-900" data-testid="ds-overdue-toggle">
        <AlertTriangle className="h-4 w-4" />Overdue dropship clients · {d.partners.length} partner(s)
        <span className="ml-auto font-bold" data-testid="ds-overdue-grand-total">{inr(d.total)} due</span></button>
      {open && <div className="mt-2 max-h-72 space-y-1.5 overflow-y-auto">{d.partners.map((p) => (
        <div key={p.partner_id} className="rounded-lg bg-white px-2.5 py-2 text-xs" data-testid={`ds-overdue-partner-${p.partner_id}`}>
          <p className="flex items-center gap-2"><b className="text-slate-800">{p.partner_name}</b>{p.code && <span className="text-slate-400">{p.code}</span>}
            <span className="ml-auto font-bold text-rose-700" data-testid={`ds-overdue-partner-total-${p.partner_id}`}>{inr(p.total)}</span></p>
          <div className="mt-1 flex flex-wrap gap-1.5">{p.clients.map((c) => (
            <button key={c.id} onClick={() => onOpen(p.partner_id, c.id)} title={c.last_paid ? `Last payment ${c.last_paid.split("-").reverse().join("/")}` : "No payment received yet"}
              className="rounded-md border border-rose-200 px-2 py-0.5 text-rose-800 hover:bg-rose-100" data-testid={`ds-overdue-client-${c.id}`}>
              {c.name} · <b>{inr(c.balance)}</b> · {c.days} days{c.last_paid ? "" : " · never paid"}</button>))}</div>
        </div>))}</div>}
    </div>
  );
};
